import React from 'react'
import {Layer, Image} from 'react-konva'
import {Node as NodeRef} from 'konva/lib/Node'
import useImage from 'use-image'
import {instance as projectsService} from '../../../services/ProjectsService'
import {useAsyncValue} from '../../../hooks/useAsyncValue'
import {ProjectAddressMapPosition} from '../../../entities/project'

export type MapLayerProps = {
  onMapNotFound?: () => void
  canvasPixelsPerM: number
  projectId: string
}

function svgToURL(s) {
  const uri = window.btoa(unescape(encodeURIComponent(s)))
  return 'data:image/svg+xml;base64,' + uri
}

export function MapLayer(props: MapLayerProps) {
  const layerRef = React.useRef<NodeRef>(null)

  const {value: projectMapImageUrl, isLoading} = useAsyncValue<string | null>(
    null,
    async () => {
      const projectMapUrlResponse = await projectsService.getProjectMapUrl(props.projectId)
      if (!projectMapUrlResponse.success) {
        props.onMapNotFound()
        return null
      }

      return projectMapUrlResponse.url
    },
    [props.projectId]
  )

  const {value: projectMapAttributes} = useAsyncValue<ProjectAddressMapPosition | null>(
    null,
    async () => {
      const projectMapAttributes = await projectsService.getProjectMapAttributes(props.projectId)

      return projectMapAttributes
    },
    [props.projectId]
  )

  const [mapImage] = useImage(projectMapImageUrl)

  return (
    <Layer ref={layerRef as any}>
      {mapImage && projectMapAttributes && (
        <Image
          image={mapImage}
          width={mapImage.width * projectMapAttributes.mapMetersPerPixel * 100}
          height={mapImage.height * projectMapAttributes.mapMetersPerPixel * 100}
          x={0}
          y={0}
        />
      )}
    </Layer>
  )
}
